import {config} from '../config';

export default {
    getNotificationDuration: () => config.data.durations.notification,
    getSearchDelayDuration: () => config.data.durations.searchDelay,
};
